import { darken } from 'polished';

const COLORS = {
	primary: '#12A34D',
	primaryLight: '#29AC68',
	secondary: '#374151',
	secondaryLight: '#4B5563',
	secondaryDark: '#1f2937',
	hover: '#F5F7FA',
	light: '#fff',
	dark: '#000',
	error: '#B91C1C',
};

const COLORS_BRAND = {
	primary: '#2bb673',
	secondary: '#12424d',
	secondaryLight: '#293E60'
};

const COLORS_GRAY = {
	100: '#F3F4F6',
	150: '#f5f6fa',
	200: '#f5f5f5',
	210: '#F5F7FE',
	250: '#e5e5e5',
	300: '#D3D8D8',
	350: '#E5E7EB',
	400: '#d6e0e0',
	500: '#cccccc',
	550: '#D1D5DB',
	600: '#9CA3AF',
	650: '#6B7280',
	700: '#555',
	800: '#666666',
};

const COLORS_WARNING = {
	light: '#FEE2E2',
	base: '#DC2626',
	dark: '#B91C1C',
};

const COLORS_SUCCESS = {
	light: '#a2d0b3',
	base: '#12A34D',
	dark: darken('0.2', '#12A34D'),
};

const COLORS_BORDER = {
	brand: COLORS_SUCCESS.light,
	primary: COLORS_GRAY['300'],
	settings: '#E2E6E6',
	invalid: COLORS_WARNING.dark,
	dropdownMenu: 'rgba(0,0,0,0.15)',
};

const COLORS_TEXT = {
	dark: COLORS_BRAND.secondary,
	subtitle: '#728E94',
	dropdownOption: '#273949',
	dropdownOptionHover: '#1e2c38',
	dropdownOptionDisabled: '#c6d0d5',
};

export {
	COLORS_BRAND,
	COLORS_GRAY,
	COLORS,
	COLORS_BORDER,
	COLORS_SUCCESS,
	COLORS_WARNING,
	COLORS_TEXT,
};
